<template>
  <div class="-mx-3 lg:mx-0">
    <div class="text-center pt-8 lg:pt-4 pb-[2rem] lg:pb-[1.875rem] px-6 lg:px-0">
      <p class="text-strong font-semibold">Newsfeed</p>
      <h1 class="text-strongest text-[32px] lg:text-4xl font-semibold">
        Latest From Phoenix Energy
      </h1>
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-4 gap-8">
      <NewsfeedLeftColumn class="hidden lg:flex" />
      <NewsfeedCenterColumn />
      <NewsfeedRightColumn class="hidden lg:flex" />
    </div>
    <div class="grid grid-cols-4 mt-14">
      <div class="hidden lg:block col-span-1"></div>
      <NewsfeedBottomContent class="col-span-4 lg:col-span-3" />
    </div>
    <NewsfeedFooter />
  </div>
</template>

<script setup>
import NewsfeedFooter from "./NewsfeedFooter.vue";
import NewsfeedBottomContent from "./NewsfeedBottomContent.vue";
import NewsfeedLeftColumn from "./NewsfeedLeftColumn.vue";
import NewsfeedRightColumn from "./NewsfeedRightColumn.vue";
import NewsfeedCenterColumn from "./NewsfeedCenterColumn.vue";
</script>
